import type { ChangePasswordFormType } from '../schemas';
import { useFirebaseAuthMutations } from './mutations';
import { useToast } from '@packages/chakra-v3';

const useChangePassword = () => {
	const { showSuccess, showError } = useToast();
	const { updatePasswordMutation } = useFirebaseAuthMutations();

	const handleChangePassword = async(changePasswordFormData: ChangePasswordFormType) => {
		await updatePasswordMutation.mutateAsync(changePasswordFormData,
			{
				onSuccess: () => showSuccess({
					title:       'Password changed successfully',
					description: 'You can now login with your new password',
				}),
				onError: () => showError({
					title:       'Password change failed',
					description: 'Please try again',
				}),
			});
	};

	return { handleChangePassword };
};

export default useChangePassword;